import axios from 'axios'

export default {
    initConfig() {

    },

    share(title, url, desc, imgUrl) {
        // if (!/micromessenger/i.test(navigator.userAgent)) {
        //     return
        // }
        let shareImg = imgUrl || window.location.origin + '/static/logo.png'
        let shareDesc = desc || '51Testing软件测试培训网,专业的软件测试培训中心,十多年来专注为客户提供软件测试就业培训,周末培训,企业内训,ISTQB认证培训等服务,在上海,北京,深圳,成都,南京,西安,武汉,杭州,重庆,广州等地设有分支机构.'
        /*wx.ready(() => {
            WeixinJSBridge.call('showOptionMenu'); //显示右上角三个点按钮。
            wx.updateAppMessageShareData({
                title: title, // 分享标题
                desc: shareDesc, // 分享描述
                link: url, // 分享链接 默认以当前链接
                imgUrl: shareImg // 分享图标
            })
            wx.updateTimelineShareData({
                title: title,
                link: url,
                desc: shareDesc, // 分享描述
                imgUrl: shareImg
            })
            wx.onMenuShareAppMessage({ // 分享给朋友，此方法即将被废弃，改用 updateAppMessageShareData
                title: title,
                desc: shareDesc,
                link: url,
                imgUrl: shareImg
            })
            wx.onMenuShareTimeline({ //分享到朋友圈，此方法即将被废弃，改用 updateTimelineShareData
                title: title,
                desc: shareDesc, // 分享描述
                link: url,
                imgUrl: shareImg
            })
            wx.error(res => {
                console.log(res, 2)
            })
        })*/
    },
}


// WEBPACK FOOTER //
// ./src/assets/share.js